import { OIDCHttpClient } from "lib/oidc_http_client";

export const identifyProduct = async (productId: number, payload: any) => {
  const url = `${process.env.REACT_APP_API_URL}/murfy-erp/products/${productId}/identification/`;
  const client = new OIDCHttpClient();
  try {
    const response = await client.post(url, payload);
    return response;
  } catch (error) {
    const err = error as any;
    if (err.response) {
      return err.response.data;
    }
    throw error;
  }
};
